import { Box, Toolbar, Typography } from '@mui/material';
import React, { useState } from 'react';
import { DCollapseButton } from '../button';

export function DSection({
    children,
    title = '',
    alwaysOpen = false,
    compact = false,
    action,
}: {
    children: React.ReactNode | React.ReactNode[];
    title?: string;
    alwaysOpen?: boolean;
    compact?: boolean;
    action?: React.ReactNode;
}) {
    const [open, setOpen] = useState(alwaysOpen);

    return (
        <Box
            flexDirection={'column'}
            mb={compact ? 1 : 2}
            justifyContent={'stretch'}
            alignItems={'stretch'}
        >
            {title || !alwaysOpen ? (
                <Toolbar
                    disableGutters
                    variant={'dense'}
                    onClick={!alwaysOpen ? () => setOpen((o) => !o) : undefined}
                    sx={{ cursor: !alwaysOpen ? 'pointer' : 'default' }}
                >
                    {!alwaysOpen ? (
                        <Box sx={{ ml: 2, mr: 1 }}>
                            <DCollapseButton open={open} setOpen={setOpen} />
                        </Box>
                    ) : null}

                    <Typography
                        sx={{
                            ml: alwaysOpen ? 2 : undefined,
                            fontWeight: 'bold',
                            flexGrow: 1,
                        }}
                    >
                        {title}
                    </Typography>
                    {action ?? null}
                </Toolbar>
            ) : null}

            {open ? (
                <Box sx={{ my: compact ? 0.5 : 2, px: 2 }}>{children}</Box>
            ) : null}
        </Box>
    );
}
